import {Injectable} from '@angular/core';
import {IColumnSettings} from 'app/main/shared/shared/table/components/custom-columns-settings/column-settings';
import {ICustomColumnService} from '../../../interfaces/custom-columns';
import {DocumentListingApiService} from './document-listing.api.service';

@Injectable({
    providedIn: 'root'
})
export class DocumentCustomColumnService implements ICustomColumnService {
    constructor(private documentListingApi:DocumentListingApiService) {
    }
    getCustomColumns(): Omit<IColumnSettings<unknown>, 'uuid'>[] {
         return this.documentListingApi.getDefaultDocumentColumns()
    }
}
